import { Box, Link, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const SingleTypeLinkContainer = styled(Box)`
  display: flex;
  align-items: flex-start;

  &:not(:only-child):not(:last-child) {
    margin-bottom: 10px;
  }

  & > .MuiBox-root,
  & > .MuiTextField-root {
    flex-basis: 50% !important;
  }

  & > a {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-left: 10px;
    margin-top: 8px;
    background-color: ${colorPalette.navy900};

    svg {
      width: 16px;
      height: 16px;
      stroke-linecap: round;
      fill: ${colorTokens.text.secondary};
    }
  }
`;

export const TypeLinkBorder = styled.span`
  display: block;
  width: 4px;
  height: 40px;
  border-radius: 2px;
  background-color: ${colorTokens.border.light};
  margin: 0 10px;
`;

export const Error = styled(Text)`
  margin: 5px 16px 0;
  font-size: 13px;
  font-weight: 300;
  color: ${colorTokens.error.main};
`;

export const ClearButton = styled(Link)`
  text-align: right;
  font-size: 14px;
  margin: 10px 0;
`;
